import { ElasticSearch } from 'dsilo-ui-components';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const ElasticSearchWrapper = () => {

    return (
        <div>
            <ElasticSearch />
        </div>
    );
}

const mapDispatchToProps = {
};

const mapStateToProps = state => {
    return {
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ElasticSearchWrapper));
